import PageLayout from 'atoms/pageLayout/pageLayout';
import React from 'react';
import GDPR from 'organisms/GDPR';

const GDPRPage = () => (
  <PageLayout>
    <GDPR
      tileProps={{
        wrapperStyle: {
          width: 'unset',
          marginTop: 16,
        },
      }}
    />
  </PageLayout>
);

export default GDPRPage;
